export const USER = {
  averageAgeOfFirstTimeBuyer: 33,
};
